export async function persistLeadAutomaticExit(record,date,{operationId,request=fetch}={}) {
  const key=String(record._rawPhone || record.id || '').replace(/^aurora_/,'');
  const response=await request('/api/crm/leads/automatic-exit',{
    method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({leadKey:key,date,expectedDate:record.proxima_data_contato || '',operationId}),
  });
  const payload=await response.json();
  if(!response.ok || !payload.ok || !payload.lead)throw Error(payload.error || 'Não foi possível confirmar o reagendamento.');
  if(typeof window!=='undefined')window.dispatchEvent(new CustomEvent('arflow:reminders-refresh'));
  return {...record,...payload.lead,id:record.id,_rawPhone:key};
}

// Accounting rows are not reminders: never expose them as pending/completed,
// never persist them back, and never give them a contact link.
export function remindersWithAccounting(payload) {
  return [...(payload.reminders || []).filter(Boolean),
    ...(payload.missedOccurrences || []).map(entry=>({...entry,id:`missed-${entry.id}`,
      status:'missed',accountingOnly:true,text:'Afazer não feito na data — reagendado pelo sistema'}))];
}
